import { render, staticRenderFns } from "./SmallStats.vue?vue&type=template&id=22be0ff8&"
import script from "./SmallStats.vue?vue&type=script&lang=js&"
export * from "./SmallStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports